/**
 * Cookie の値を取得します。
 *
 * @param {string} key - 取得するCookieのキー
 * @returns {string} 指定したキーのCookieの値。該当するキーがない場合は空文字を返します。
 */
export function getCookie(key) {
    const cookies = document.cookie.split(';');
    const encodedKey = encodeURIComponent(key);

    for (const cookie of cookies) {
        const trimmed = cookie.trim();
        // 値に = が含まれることがあるため、最初の = だけで分割する
        const separatorIndex = trimmed.indexOf('=');
        if (separatorIndex === -1 || trimmed.slice(0, separatorIndex) !== encodedKey) {
            continue;
        }

        const value = trimmed.slice(separatorIndex + 1);
        try {
            return decodeURIComponent(value);
        } catch {
            // 他システムが設定した Cookie など、不正な % を含む値は
            // decodeURIComponent が例外を投げるため、生の値をそのまま返す
            return value;
        }
    }

    return '';
}
